import { ValueFormatterParams } from 'ag-grid-community';
import { formatCurrency, formatNumber, formatPercent } from 'modules/I18N';
import { AggregationFunction } from 'components/common/AllocationReport/AllocationReport.types';
import { MetricType, ValueFormatter } from 'components/common/types/DrilldownReports.types';

export const valueFormatters: Record<MetricType, ValueFormatter> = {
  [MetricType.IMPRESSIONS]: (value, localeCode) => formatNumber({ value, localeCode, digits: 0 }),
  [MetricType.SOT]: (value, localeCode) => formatPercent({ value, localeCode, maximumFractionDigits: 2 }),
  [MetricType.FRAMES]: (value, localeCode) => formatNumber({ value, localeCode, digits: 0 }),
  [MetricType.PRICE_GROSS]: (value, localeCode, currencyCode) =>
    formatCurrency({ value, localeCode, currencyCode: currencyCode as string }),
  [MetricType.PRICE_INDEXED]: (value, localeCode, currencyCode) =>
    formatCurrency({ value, localeCode, currencyCode: currencyCode as string }),
};

export const createValueFormatter = (selectedMetricType: MetricType, localeCode: string, currencyCode?: string) => {
  return (params: ValueFormatterParams): string => {
    if (params.value === 0) {
      return '-';
    }

    if (typeof params.value === 'number') {
      return valueFormatters[selectedMetricType](params.value, localeCode, currencyCode);
    }

    if (params.colDef.aggFunc === AggregationFunction.AVG && params?.value?.value != null) {
      return valueFormatters[selectedMetricType](params.value.value, localeCode, currencyCode);
    }

    return '';
  };
};
